<template>
  <v-icon v-if="isActive" color="success">done</v-icon>
  <v-icon v-else color="red">close</v-icon>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
  },
}
</script>

<style scoped></style>
